import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cross\">\r\n    <path d=\"M5.2 6.2a.668.668 0 010-1 .668.668 0 011 0L12 11l5.8-5.8a.668.668 0 011 0 .668.668 0 010 1L13 12l5.8 5.8a.707.707 0 01-1 1L12 13l-5.8 5.8a.668.668 0 01-1 0 .668.668 0 010-1L11 12z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol